import { render } from "./SetOrderStatusForm.vue?vue&type=template&id=ebdf8190"
import script from "./SetOrderStatusForm.vue?vue&type=script&lang=js"
export * from "./SetOrderStatusForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__